/** 시수 자동 조정 옵션3: 편제별 목표 1·2학기 편성 시수 (로컬 전용) */

export type HoursAdjustUserScheduledPair = {
  term1: string;
  term2: string;
};

function storageKey(workspaceId: string, gradeId: string): string {
  return `cp.hoursAdjust.userScheduled.v1.${workspaceId}.${gradeId}`;
}

function isPair(v: unknown): v is HoursAdjustUserScheduledPair {
  return (
    Boolean(v) &&
    typeof v === 'object' &&
    !Array.isArray(v) &&
    typeof (v as HoursAdjustUserScheduledPair).term1 === 'string' &&
    typeof (v as HoursAdjustUserScheduledPair).term2 === 'string'
  );
}

/** 로드. 없으면 빈 객체(입력란은 빈칸). */
export function loadHoursAdjustUserScheduledByTrack(
  workspaceId: string,
  gradeId: string,
): Record<string, HoursAdjustUserScheduledPair> {
  if (!workspaceId || !gradeId) return {};
  try {
    const raw = window.localStorage.getItem(storageKey(workspaceId, gradeId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, HoursAdjustUserScheduledPair> = {};
    Object.entries(parsed as Record<string, unknown>).forEach(([track, pair]) => {
      const name = track.trim();
      if (!name || !isPair(pair)) return;
      out[name] = { term1: pair.term1, term2: pair.term2 };
    });
    return out;
  } catch {
    return {};
  }
}

export function saveHoursAdjustUserScheduledByTrack(
  workspaceId: string,
  gradeId: string,
  value: Record<string, HoursAdjustUserScheduledPair>,
): void {
  if (!workspaceId || !gradeId) return;
  try {
    window.localStorage.setItem(storageKey(workspaceId, gradeId), JSON.stringify(value));
  } catch {
    /* quota / private mode */
  }
}
